const textarea = document.getElementById('message')
const email = document.getElementById('email')

// Function to resize textarea dynamically
const autoResize = (event) => {
  textarea.style.height = 'auto' // Reset height
  textarea.style.height = `${textarea.scrollHeight}px` // Set new height based on content
}

// Add input event listener
textarea.addEventListener('input', autoResize)

const API_KEY = '51f4083c19d5493882b2eb69042b1d30'

const validateEmail = async (email) => {
  const response = await fetch(
    `https://emailvalidation.abstractapi.com/v1/?api_key=${API_KEY}&email=${email}`
  )
  const data = await response.json()

  return data.is_valid_format.value && !data.is_disposable_email.value
}

;(function () {
  emailjs.init('Z3HpRRtxev1mrH6m_') // Replace with your EmailJS user ID
})()

function sendEmail(event) {
  event.preventDefault(); // Prevent form from submitting normally
  
  // Assuming validateEmail returns a promise, we handle it using .then() or async/await
  validateEmail(email.value).then(isValid => {
    if (!isValid) {
      alert('Please enter a valid email address.');
      return; // Stop further execution if email is invalid
    }

    // Proceed with sending the email if validation passes
    emailjs
      .sendForm('service_4seelf7', 'template_rbn1k1r', event.target)
      .then(
        function (response) {
          console.log('Sent successfully', response);
          alert('Thank you for your message! We will get back to you shortly.');
          document.getElementById('contact-form').reset(); // Clear the form
          updateCharCount();
        },
        function (error) {
          console.log('Failed', error);
          alert('Oops! Something went wrong. Please try again.');
        }
      );
  }).catch(error => {
    console.error('Error validating email:', error);
    alert('There was an error validating the email address.');
  });
}

function updateCharCount() {
  const message = document.getElementById('message');
  const charCount = message.value.length;
  document.getElementById('char-count').textContent = `${charCount}/1000`;
}